'use client';

import { LoadingBlock } from '@repo/features/LoadingBlock';

export default function Loading() {
  return <LoadingBlock />;
}
